import React, { Component } from 'react';
import PropTypes from 'prop-types'
import BreadCrumb from '../../components/elements/common/BreadCrumb';
import AdminProducts from '../../components/partials/adminControl/AdminProducts';
import ContainerPage from '../../components/layouts/ContainerPage';

import { connect } from 'react-redux'

class AdminProductsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadCrumb: [
                {
                    text: 'Admin',
                    url: '/',
                },
                {
                    text: 'Products',
                },
            ],
        };
    }

    render() {
        const {
          user: {
            credentials: {email, date_created, imageUrl, bio, bid, website, address, auth_token},
            loading,
            authenticated
          }
        } = this.props

        let profileMarkup = !loading ? (authenticated ? (
          <div>AUTHENTICATED</div>
        ) : (
          <div>Not authenticated, please signup/login</div>
        )) : (<p>Loading...</p>)
        return (
            <ContainerPage title="My Account">
                <div className="ps-page--my-account">
                    <BreadCrumb breacrumb={this.state.breadCrumb} />
                    <AdminProducts />

                </div>
            </ContainerPage>
        );
    }
}

const mapStateToProps = (state) => ({
  user: state.user,
  ui: state.ui
})

AdminProductsPage.propTypes = {
  user: PropTypes.object.isRequired,
  ui: PropTypes.object.isRequired
}

export default connect(mapStateToProps)(AdminProductsPage);
